function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export const ProjectLargeIcon = (_0)=>{
    let { color = '#424960' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    var _props_width, _props_width1, _ref, _ref1;
    var _props_width2, _props_width3;
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: (_props_width = props.width) !== null && _props_width !== void 0 ? _props_width : 40,
        height: (_props_width1 = props.width) !== null && _props_width1 !== void 0 ? _props_width1 : 40,
        viewBox: "0 0 ".concat((_ref = (_props_width2 = props.width) === null || _props_width2 === void 0 ? void 0 : _props_width2.toString()) !== null && _ref !== void 0 ? _ref : 40..toString(), " ").concat((_ref1 = (_props_width3 = props.width) === null || _props_width3 === void 0 ? void 0 : _props_width3.toString()) !== null && _ref1 !== void 0 ? _ref1 : 40..toString()),
        fill: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M34.9071 11.8628C34.9071 11.8628 34.9071 11.8628 34.9071 11.7215L34.801 11.4563C34.7641 11.4001 34.7227 11.3469 34.6773 11.2973C34.63 11.2225 34.5768 11.1515 34.5182 11.0852L34.3592 10.9615L34.0764 10.8201L20.8209 2.63706C20.54 2.4615 20.2155 2.36841 19.8842 2.36841C19.553 2.36841 19.2284 2.4615 18.9475 2.63706L5.79811 10.8201L5.63905 10.9615L5.47998 11.0852C5.42139 11.1515 5.3682 11.2225 5.32091 11.2973C5.27548 11.3469 5.23411 11.4001 5.1972 11.4563L5.09115 11.7215C5.09115 11.7215 5.09115 11.7215 5.09115 11.8628C5.07378 12.0155 5.07378 12.1697 5.09115 12.3224V27.7694C5.09055 28.0697 5.16651 28.3653 5.31185 28.6281C5.45719 28.891 5.66712 29.1125 5.92183 29.2717L19.1773 37.4547C19.2589 37.5051 19.3485 37.5409 19.4424 37.5607C19.4424 37.5607 19.5307 37.5607 19.5838 37.5607C19.8828 37.6556 20.2038 37.6556 20.5028 37.5607C20.5028 37.5607 20.5912 37.5607 20.6442 37.5607C20.738 37.5409 20.8277 37.5051 20.9093 37.4547L34.0764 29.2717C34.3311 29.1125 34.541 28.891 34.6864 28.6281C34.8317 28.3653 34.9077 28.0697 34.9071 27.7694V12.3224C34.9244 12.1697 34.9244 12.0155 34.9071 11.8628ZM18.1699 32.7888L8.4492 26.7796V15.5037L18.1699 21.4951V32.7888ZM19.9372 18.4375L10.0399 12.3224L19.9372 6.22486L29.8346 12.3224L19.9372 18.4375ZM31.4253 26.7796L21.7046 32.7888V21.4951L31.4253 15.5037V26.7796Z",
            fill: color
        })
    });
};
